import { Home, LayoutDashboard, Package, LayoutGrid } from 'lucide-react';
import { UPSELLING_HIDDEN } from '../../features/upselling/upsellingConstants';

/**
 * The staff's sidebar. The shape is documented in `Sidebar`.
 *
 * The admin's menu plus "Operadores", which opens the Panel de Control group —
 * where the legacy puts it, right above the sellers. Its own file rather than a
 * derivation of the admin's: the internal team's menu is going to grow on its
 * own, and a menu that quietly inherits is a menu nobody dares to change.
 *
 * The labels drop the possessive the admin's menu uses: nothing here belongs to
 * whoever is signed in — the internal team looks at every operator's sellers,
 * alliances and zones, so "Mis Zonas" would be naming somebody else's.
 */
export const staffNavigation = [
  { type: 'link', to: '/home', icon: Home, label: 'Inicio' },
  { type: 'link', to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  {
    type: 'section',
    key: 'deliveries',
    to: '/deliveries',
    icon: Package,
    label: 'Deliveries',
    children: [
      { to: '/deliveries', label: 'Historial', end: true },
      { to: '/deliveries/attention', label: 'Alerta' },
      // Upselling is hidden for now, and its routes with it: see `UPSELLING_HIDDEN`.
      ...(UPSELLING_HIDDEN ? [] : [{ to: '/incoming-upsells', label: 'Upselling' }]),
    ],
  },
  {
    type: 'group',
    key: 'panel',
    icon: LayoutGrid,
    label: 'Panel de Control',
    children: [
      { to: '/admins', label: 'Operadores' },
      { to: '/sellers', label: 'Sellers' },
      ...(UPSELLING_HIDDEN ? [] : [{ to: '/partnerships', label: 'Alianzas' }]),
      { to: '/my-providers-credentials', label: 'Proveedores' },
      { to: '/external-integrations', label: 'Servicios externos' },
      { to: '/shipping-zones', label: 'Zonas' },
      // Mailing is out of every menu for now: no tree ever served `/mailing`,
      // so the item only ever led to the "page does not exist" screen.
    ],
  },
];
